import { Component, OnInit, EventEmitter, Output } from '@angular/core';

import { Assessment } from '../models/assessment';
import { AssessmentService } from '../services/assessment.service';
import { AssessmentTokenService } from '../services/assessment-token.service';
import { AuthService } from 'app/login/services/auth.service';
import { Capability } from '../models/capability';

@Component({
  selector: 'dac-assessment-picker',
  templateUrl: './assessment-picker.component.html',
  styleUrls: ['./assessment-picker.component.css']
})
export class AssessmentPickerComponent implements OnInit {

  @Output() selected = new EventEmitter<Assessment>();
  @Output() buy = new EventEmitter<Assessment>();
  private _assessments: Assessment[];
  private _search: string;
  private _loadedTokens: boolean;
  private _canBuy:boolean;
  

  constructor(private assessmentService:AssessmentService
  ,private assessmentTokenService:AssessmentTokenService
  ,private authService:AuthService) { 
    this._loadedTokens = false;
  }

  public get tokensEnabled() {
    return this.assessmentTokenService.isTokensEnabled();
  }

  ngOnInit() {

    this.authService.getCurrentUser().then(currentUser => {
      this._canBuy = currentUser.hasCapability(Capability.CAN_SHOP);
      this.assessmentService.getAssessmentList().then((assessments: Assessment[]) => {
          this._assessments = assessments;
          return assessments;
        })
        .then((assessments) => {
          return this.assessmentTokenService.loadAssessmentTokens().then(() => {
            this._loadedTokens = true;
          })
        });
    })
    .catch(error => {
      // TODO: stephen do we need to do something with the current user here?
      console.error(error);
    })
  }

  public getRemainingTokens(assessment:Assessment) : any {
    if (!this._loadedTokens) {
      return 0;
    }
    return this.assessmentTokenService.getRemainingTokens(assessment);
  }

  public shouldBuyTokens(assessment:Assessment) {
    if (!this._loadedTokens) {
      return false;
    }
    return this._canBuy && this.assessmentTokenService.getRemainingTokens(assessment) <= 0;
  }

  public get hasLoaded() {
    return this._loadedTokens;
  }

  public pickAssessment(assessment: Assessment) {
    console.log("selecting ", assessment);
    this.selected.emit(assessment);
  }

  get assessments() {
    return this._assessments;
  }

  get search(): string {
    return this._search;
  }

  set search(v: string) {
    this._search = v;
  }

  doSearch(): void {
    alert("not implemented yet");
  }

  resetSearch(): void {
    alert("not implemented yet");
  }

  enterKeySearch(event: any): void {
      alert("not implemented yet");
    }
  
  triggerBuy(item:Assessment) {
    this.buy.emit(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/assessment-picker/assessment-picker.component.ts